import { Component, HostListener, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('zepbazaar-admin');

  @HostListener('document:keydown', ['$event'])
  protectNumericKeyInput(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement | null;
    if (!input || input.tagName !== 'INPUT' || input.disabled || input.readOnly) return;
    const digitsOnly = input.inputMode === 'numeric' || input.type === 'tel';
    const numericAmount = input.type === 'number';
    if (!digitsOnly && !numericAmount) return;
    if (event.ctrlKey || event.metaKey || event.altKey || ['Backspace', 'Delete', 'Tab', 'Enter', 'Escape', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    if (digitsOnly && !/^\d$/.test(event.key)) event.preventDefault();
    if (numericAmount) {
      if (/^\d$/.test(event.key)) return;
      if (event.key === '.' && !input.value.includes('.')) return;
      if (event.key === '-' && !input.value && Number(input.min) < 0) return;
      event.preventDefault();
    }
  }

  @HostListener('document:input', ['$event'])
  sanitizeNumericInput(event: Event): void {
    const input = event.target as HTMLInputElement | null;
    if (!input || input.tagName !== 'INPUT') return;
    const digitsOnly = input.inputMode === 'numeric' || input.type === 'tel';
    if (digitsOnly) {
      const sanitized = input.value.replace(/\D/g, '').slice(0, input.maxLength > 0 ? input.maxLength : undefined);
      if (sanitized !== input.value) {
        input.value = sanitized;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
      return;
    }
    if (input.type === 'number' && input.value) {
      const allowNegative = Number(input.min) < 0;
      const normalized = input.value
        .replace(/[^0-9.-]/g, '')
        .replace(/(\..*)\./g, '$1')
        .replace(allowNegative ? /(?!^)-/g : /-/g, '');
      if (normalized !== input.value) input.value = normalized;
    }
  }
}
